export const preventNav = (event) => {
  event.preventDefault()
  event.returnValue = ''
}
